import AdminResellerFormModule from '@/modules/admin-reseller-form/AdminResellerFormModule';

export default AdminResellerFormModule;
